'use client'

import { useState } from 'react'
import {
    EmbedGif as EmbedGifType,
    appendTrackingQuery,
    getExternalMediaUrl,
    getGifImageUrl,
    getGifWebpUrl,
} from '../helpers'
import { GiphyMark } from './giphy-logo'

type Props = {
    gif: EmbedGifType
    hideVideo?: boolean
    trackingQueryString?: string
}

export default function EmbedGifMobile({ gif, hideVideo = false, trackingQueryString }: Props) {
    const [footerOpen, setFooterOpen] = useState(false)
    const [mediaOpen, setMediaOpen] = useState(false)
    const gifUrl = appendTrackingQuery(gif.url, trackingQueryString)
    const imageUrl = getGifImageUrl(gif)
    const webpUrl = getGifWebpUrl(gif)
    const mediaUrl = hideVideo ? '' : getExternalMediaUrl(gif.external_media)

    if (mediaOpen && mediaUrl) {
        return (
            <div className="relative h-dvh w-full bg-black text-giphyWhite">
                <iframe title={gif.title || 'GIPHY media'} src={mediaUrl} className="h-full w-full" allow="autoplay" />
                <button
                    type="button"
                    className="absolute right-3 bottom-3 bg-giphyBlack/90 px-3 py-2 text-xs font-black uppercase transition hover:bg-giphyCharcoal"
                    onClick={() => setMediaOpen(false)}
                >
                    GIF
                </button>
            </div>
        )
    }

    return (
        <div className="relative h-dvh w-full overflow-hidden bg-giphyBlack text-giphyWhite">
            <a
                href={gifUrl}
                target="_blank"
                rel="noreferrer"
                className="absolute inset-0 block"
                aria-label={gif.title}
                onClick={
                    mediaUrl
                        ? (event) => {
                              event.preventDefault()
                              setFooterOpen((value) => !value)
                          }
                        : undefined
                }
            >
                <picture>
                    {webpUrl && <source srcSet={webpUrl} type="image/webp" />}
                    <img src={imageUrl} alt={gif.alt_text || gif.title || ''} className="h-dvh w-full object-contain" />
                </picture>
            </a>

            {mediaUrl && footerOpen && (
                <div className="absolute inset-x-0 bottom-0 z-20 flex h-9 bg-giphyDarkGrey text-giphyWhite">
                    <button
                        type="button"
                        className="flex flex-1 items-center justify-center text-xs font-black uppercase"
                        onClick={() => setMediaOpen(true)}
                    >
                        Watch
                    </button>
                    <a
                        href={gifUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="flex flex-1 items-center justify-center gap-2 border-l border-giphyBlack text-xs font-black text-giphyWhite uppercase no-underline"
                    >
                        <GiphyMark className="h-[18px] w-[14px]" />
                        <span>View on GIPHY</span>
                    </a>
                </div>
            )}
        </div>
    )
}
